import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetDealerAddressPriceListDropdownQuery } from '../../api/endpoints/priceList';

/**
 * Price List dropdown component with search functionality
 * @param {Object} props
 * @param {string|Object} props.value - The selected value
 * @param {Function} props.onChange - Callback when selection changes
 * @param {string} props.className - Additional CSS classes
 * @param {boolean} props.disabled - Whether the dropdown is disabled
 * @param {string} props.placeholder - Placeholder text
 */
const PriceListDropdown = ({ 
    value, 
    onChange, 
    className = '', 
    disabled = false, 
    placeholder = 'Fiyat listesi seçiniz veya arayınız' 
}) => {
    const [selectedPriceList, setSelectedPriceList] = useState(null);

    // Fetch price list from API
    const { data: priceListResponse, isLoading: isLoadingPriceList } = useGetDealerAddressPriceListDropdownQuery();

    // Transform price list for dropdown
    const priceListOptions = (priceListResponse || []).map((priceList) => ({
        id: priceList.listHeaderId || priceList.id,
        name: priceList.priceListName || priceList.name || priceList.listHeaderName,
        listHeaderId: priceList.listHeaderId || priceList.id,
        displayValue: `${priceList.listHeaderId || priceList.id} - ${priceList.priceListName || priceList.name || priceList.listHeaderName}`
    }));

    // Handle selection change
    const handleSelectionChange = (e) => {
        setSelectedPriceList(e.value);
        onChange(e.value ? e.value : null);
    };

    // Set initial value if available
    useEffect(() => {
        if (value && priceListOptions.length > 0 && !selectedPriceList) {
            const found = priceListOptions.find((option) => 
                option.id === value.id || 
                option.listHeaderId === value.listHeaderId ||
                option.id === value ||
                option.listHeaderId === value
            );
            if (found) {
                setSelectedPriceList(found);
            }
        } else if (!value) {
            setSelectedPriceList(null);
        }
    }, [value, priceListOptions, selectedPriceList]);

    return (
        <Dropdown
            value={selectedPriceList}
            options={priceListOptions}
            onChange={handleSelectionChange}
            optionLabel="displayValue"
            filter
            showClear
            filterBy="id,name"
            className={className}
            placeholder={placeholder}
            loading={isLoadingPriceList}
            disabled={disabled}
            virtualScrollerOptions={{ itemSize: 38 }}
            itemTemplate={(option) => (
                <div>
                    <span style={{ fontWeight: 'bold' }}>{option.id}</span> - {option.name}
                </div>
            )}
        />
    );
};

export default PriceListDropdown; 